import axios from 'axios';

const libraryCategory = {
    namespaced: true,
	actions: {		
		ProcessLibraryCategory(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/LibraryCategory/ProcessLibraryCategory', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 		
		GetLibraryCategory({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryCategory/GetLibraryCategory?Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 
		GetByIdLibraryCategory({rootState}, Id){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryCategory/GetByIdLibraryCategory?Id=${Id}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}
	}
}

export default libraryCategory